import React, { useEffect, useState } from 'react';
import axios from 'axios';

import Splash from './../../components/Splash';
import Header from '../../components/Header';
import Hero from './../../components/Hero';
import Intro from './../../components/Intro';
import Letter from './../../components/Letter';
import Articles from '../../components/Articles';
import Stats from './../../components/Stats';
import Trustees from './../../components/Trustees';
import HeroLarge from './../../components/HeroLarge';

const App = () => {
  const [data, setData] = useState({});
  const [isSplashVisible, setIsSplashVisible] = useState(false);
  const [slide, setSlide] = useState(null);
  const hasData = !!Object.keys(data)?.length;
  const fetchData = () => axios.get('assets/data/data.json');
  const {
    articles = [],
    back_cover: backCover = {},
    front_cover: frontCover = {},
    intro = {},
    letter = {},
    nav = {},
    stats = {},
    trustees = {},
  } = data;

  useEffect(() => {
    fetchData().then(({ data }) => {
      setData(data);
    });
  }, []);

  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      window.scrollTo(0, 0);
    });
  }, []);

  useEffect(() => {
    const handleViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    handleViewportHeight();
    window.addEventListener('resize', () => handleViewportHeight());
  }, []);

  return (
    <main id='main'>
      <Splash setIsSplashVisible={setIsSplashVisible} id='splash' />
      {hasData && (
        <>
          <Header id='header' {...nav} isVisible={!isSplashVisible} />
          <Hero id='front-cover' {...frontCover} />
          <Intro id='intro' {...intro} items={[...nav.items]} setSlide={setSlide} />
          <Letter id='letter-from-the-president' {...letter} />
          <Articles items={articles} slide={slide} key={slide} />
          <Stats id='mi-by-the-numbers' branding {...stats} />
          <Trustees id='board-of-trustees' {...trustees} />
          <HeroLarge id='back-cover' donate={nav?.donate} {...backCover} />
        </>
      )}
    </main>
  );
};

export default App;
